import Form from "react-bootstrap/Form";
import React, { Fragment } from "react";

interface IProps {
    title: string;
    disabled?: boolean;
    displayLength: boolean;
    maxCharAllowed: number;
    placeholder: string;
    keys: string;
    formValue: string;
    invalidState: boolean;
    invalidText: string;
    whichCSS: boolean;
    formWidth: any;
    onInputChange(e: any): any;
}

function UClientDetailsForm(props: IProps) {
    const onSubmitForm = (event: any) => {
        event.preventDefault();
    };

    return (
        <Fragment>
            <div className="zeroClientCanvasForm">
                <div className="overallZeroClientHeaders">
                    <div className="zeroClientCanvasQuestionHeader">
                        <div className="zeroClientCanvasTitle">{props.title}</div>
                    </div>

                    {props.displayLength && (
                        <div>
                            {props.formValue ? props.formValue.length : 0}/{props.maxCharAllowed}
                        </div>
                    )}
                </div>

                {props.whichCSS && (
                    <Form className="formcontrolZeroClientDescription" onSubmit={onSubmitForm}>
                        <Form.Group className="form-group" style={{ width: "100%" }}>
                            <Form.Control
                                disabled={props.disabled}
                                maxLength={props.maxCharAllowed}
                                as="textarea"
                                placeholder={props.placeholder}
                                value={props.formValue}
                                onChange={props.onInputChange}
                                name={props.keys}
                                isInvalid={props.invalidState}
                            />
                        </Form.Group>
                    </Form>
                )}

                {!props.whichCSS && (
                    <Form onSubmit={onSubmitForm} className="formcontrolZeroClient">
                        <Form.Group className="form-group" style={{ width: "100%" }}>
                            <Form.Control
                                disabled={props.disabled}
                                maxLength={props.maxCharAllowed}
                                as="input"
                                placeholder={props.placeholder}
                                value={props.formValue}
                                onChange={props.onInputChange}
                                name={props.keys}
                                isInvalid={props.invalidState && !props.disabled}
                            />
                            <Form.Control.Feedback type="invalid" className="invalidInputZeroClient">
                                {props.invalidText}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form>
                )}
            </div>
        </Fragment>
    );
}

export default UClientDetailsForm;
